/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  order.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

// 存储担保函数据
 const guarantee = {
   state: {
     obj: {
      opUser:'',
      companyId:'',
      userId1:'',
      orderNo:''
     }
   },
   mutations:{
    SET_OBJ(state:any,data:any) {
      state.obj = data
    }
   }
 };
 
 export default guarantee;
 